import { useState } from "react";
import { AddCategory } from "./add-category-dialog";
import { EditCategoryDialog } from "./edit-category-dialog";
import { DeleteCategoryDialog } from "./delete-category-dialog";
import CategoriesTable from "./categories-table";
import type { Category } from "@/types/services/api-types/category-types";

export const CategoriesTabContent = () => {
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState<Category | null>(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const handleCategoryClick = (category: Category) => {
    setSelectedCategory(category);
    setIsEditDialogOpen(true);
  };

  const handleEditDialogClose = (open: boolean) => {
    setIsEditDialogOpen(open);
    if (!open) {
      setSelectedCategory(null);
    }
  };

  const handleDeleteClick = (category: Category) => {
    setCategoryToDelete(category);
    setIsDeleteDialogOpen(true);
  };

  const handleDeleteDialogClose = (open: boolean) => {
    setIsDeleteDialogOpen(open);
    if (!open) {
      setCategoryToDelete(null);
    }
  };

  return (
    <div className="mt-5">
      <div className="flex justify-end mb-4 pr-4">
        <AddCategory />
      </div>
      <CategoriesTable
        onCategoryClick={handleCategoryClick}
        onDeleteClick={handleDeleteClick}
      />
      {selectedCategory && (
        <EditCategoryDialog
          category={selectedCategory}
          open={isEditDialogOpen}
          onOpenChange={handleEditDialogClose}
        />
      )}
      {categoryToDelete && (
        <DeleteCategoryDialog
          category={categoryToDelete}
          open={isDeleteDialogOpen}
          onOpenChange={handleDeleteDialogClose}
        />
      )}
    </div>
  );
};
